import createReducer from '../config/create_reducer';
import Const from '../config/const';

const getDefaultState = () => ({
  loading: false,
  page: 0,
  complete: [],
  advisor: null,
  activityItemsList: [],
  holisticServices: new Map(),
  paginationParams: null,
  activitiesLoading: false,
  errorStatus: false
});

const updateComplete = (complete, order) => {
  if (complete.length === 0) return complete;
  const updatedOrder = complete.find((item) => item.id === order.id);
  if (!updatedOrder) return complete;
  const newCompleteArray = complete;
  newCompleteArray[complete.indexOf(updatedOrder)] = order;
  return newCompleteArray;
};

const updateHolisticServices = (holisticServicesMap, newHolisticServices) => {
  if (!Array.isArray(newHolisticServices) || newHolisticServices.length === 0) {
    return holisticServicesMap;
  }
  const updatedMap = new Map(holisticServicesMap);
  newHolisticServices.forEach((service) => {
    updatedMap.set(service.id, service);
  });
  return updatedMap;
};

const advisorOrdersReducer = createReducer(getDefaultState(), {
  [Const.advisorOrders.loading]: (state) => ({
    ...state,
    loading: true
  }),
  [Const.advisorOrders.activitiesLoading]: (state) => ({
    ...state,
    activitiesLoading: true
  }),
  [Const.advisorOrders.reset] : () => (
    getDefaultState()
  ),
  [Const.advisorOrders.resetActivities] : (state) => ({
    ...state,
    activityItemsList: [],
    holisticServices: new Map(),
    paginationParams: null,
    activitiesLoading: false,
    errorStatus: false
  }
  ),
  [Const.advisorOrders.setErrorStatus] : (state, { errorStatus }) => ({
    ...state,
    errorStatus
  }),
  [Const.advisorOrders.activitiesLoaded]: (state, { payload }) => {
    const { activityItems, paginationParams, holisticServices } = payload;
    return ({
      ...state,
      ...payload,
      paginationParams: paginationParams || null,
      activityItemsList: [...state.activityItemsList, ...activityItems],
      holisticServices: updateHolisticServices(state.holisticServices, holisticServices),
      loading: false,
      activitiesLoading: false
    });
  },
  [Const.advisorOrders.activitiesResetLoaded]: (state, { payload }) => {
    const { activityItems, paginationParams, holisticServices } = payload;
    return ({
      ...state,
      ...payload,
      paginationParams: paginationParams || null,
      activityItemsList: [...activityItems],
      holisticServices: new Map(holisticServices.map(service => [service.id, service])),
      loading: false,
      activitiesLoading: false
    });
  },
  [Const.advisorOrders.activityLoaded]: (state, { payload }) => {
    const { activityItems, holisticServices } = payload;
    return ({
      ...state,
      ...payload,
      advisor: {
        ...payload.advisor,
        slug: state.advisor.slug,
        rating: state.advisor.rating
      },
      activityItemsList: [...activityItems, ...state.activityItemsList],
      holisticServices: updateHolisticServices(state.holisticServices, holisticServices),
      loading: false,
      activitiesLoading: false
    });
  },
  [Const.advisorOrders.advisorOrdersDelete]: (state, { orderId }) => ({
    ...state,
    complete: [...state.complete.filter(order => order.id !== orderId)]
  }),
  [Const.logOut.clear]: () => ({
    ...getDefaultState()
  }),
  [Const.orderDetails.updated]: (state, { orderDetails }) => ({
    ...state,
    complete: updateComplete(state.complete, orderDetails)
  })
});

export default advisorOrdersReducer;
